import { FC } from 'react';

import * as Layout from 'layouts/OffersLayout';

import useInsuranceQuery from '../../hooks/useInsuranceCoverage';
import Upgrade from './components/Upgrade';
import locales from './locales';

import offers from '../../offers';
import OfferCard from '../../components/OfferCard';
import { Link } from 'react-router-dom';

const Coverage: FC = () => {
  const { activeOffers, inactiveOffers } = useInsuranceQuery();

  const activeOffersCount = activeOffers.length;
  const inactiveOffersCount = inactiveOffers.length;

  return (
    <Layout.PageContainer
      trackViewProps={{
        pageName: 'InsurancesOffers Viewed',
        usePrefix: false,
      }}
    >
      <Layout.PageTitle
        description={locales.description}
        title={locales.title}
      />

      {activeOffersCount === 0 ? (
        <Upgrade paddingX="space-80" paddingBottom="space-48" />
      ) : null}

      {activeOffersCount > 0 ? (
        <>
          <Layout.ListTitle
            count={activeOffersCount}
            title={locales.categories.active}
          />

          <Layout.ListGrid>
            {activeOffers.map((offer) => (
              <OfferCard
                as={Link}
                key={offer.path.pathname}
                to={{ ...offer.path, state: { from: 'all-offers' } }}
                offer={offer}
              />
            ))}
          </Layout.ListGrid>
        </>
      ) : null}

      <Layout.ListTitle
        count={
          // only display the count if there is at least one inactive offer
          inactiveOffersCount > 0 ? inactiveOffersCount + 1 : 0
        }
        title={
          activeOffersCount === 0
            ? locales.categories.noCoverage
            : locales.categories.complete
        }
      />

      <Layout.ListGrid>
        {inactiveOffers.map((offer) => (
          <OfferCard
            as={Link}
            key={offer.path.pathname}
            to={{ ...offer.path, state: { from: 'all-offers' } }}
            offer={offer}
          />
        ))}

        <OfferCard
          as={Link}
          key={offers.fromPartners.path.pathname}
          to={{ ...offers.fromPartners.path, state: { from: 'all-offers' } }}
          offer={offers.fromPartners}
        />
      </Layout.ListGrid>
    </Layout.PageContainer>
  );
};

export default Coverage;
